import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from "axios";
import { setEnText, setEntity, setResult } from '../audio-recorder/asrSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';
import { Feedback } from '../feedback';
import { setId, setResponse, setResponseTag, setTimeTaken, setAsrTime, setChatTime, setProbability, setUserInput, setIsRelevant, setSession, resetSession } from './ecChatSlice';

const DialPad = () => {
    const dispatch = useDispatch();
    const enText = useSelector((state) => state.asr.enText);
    const appToken = useSelector((state) => state.auth.appToken);
    
    const updateEnText = (input) => {
        dispatch(setEnText(input))
    }

    const ecChatId = useSelector((state) => {
        console.log("Full Redux State:", state); // Log the entire Redux state
        return state.ecChat?.ecChatId;
    });

    const entity = async (input) => {

        const formData = new FormData();
        formData.append("input", input); 
        formData.append("ecChatId", ecChatId);     
        dispatch(showLoader());  

        axios
            .post(`${process.env.REACT_APP_BACKEND_URL_EC}/api/ec-asr-chat-dial-pad`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "X-API-KEY": appToken
                },
            })           
            .then((response) => {
                console.log(response);
                dispatch(setId(response.data.id));
                dispatch(setResponse(response.data.response));
                dispatch(setResponseTag(response.data.response_tag));
                dispatch(setTimeTaken(response.data.time_taken));
                dispatch(setAsrTime(response.data.asrTime));
                dispatch(setChatTime(response.data.chatTime));
                dispatch(setProbability(response.data.probability));
                dispatch(setUserInput(response.data.user_input));
                dispatch(setIsRelevant(response.data.is_relevant));

                dispatch(hideLoader()); 
                // dispatch(setSession(fileName));  
            })
            .catch((error) => {
                console.log(error);
                dispatch(hideLoader());
                dispatch(resetSession()); 
            });
    }

    return (
        <div className='translation mini-card'>
            <h4>Dial Pad</h4>
            <div>
                <textarea
                    value={enText}
                    rows="1" style={{"width": "100%"}}
                    onChange={(e) => updateEnText(e.target.value)} />
            </div>           
            <div>
               
                <Button
                    variant="outline-dark"  size="sm" onClick={(e) => entity(enText)}>Submit</Button>
                <Feedback 
                    type = {"translate"} />
            </div>
        </div>
    );
};


export default DialPad;
